module.exports = __webpack_public_path__ + "static/media/union.d7eeb792.png";